import { createAsyncStore } from "../common/axios/asyncModel";
import { NoticeRepository } from "repository/noticeRepository";

const noticeList = createAsyncStore();
const noticeDetail = createAsyncStore();

const getNoticeList = (params: any) => {noticeList.onGetAll(() => NoticeRepository.onGetNoticeList(params))}
// 다음 페이지를 기존 목록 뒤에 이어붙인다. 응답 본문의 목록 키가 data 이므로 more: 'data'.
const getNoticeListMore = (params: any) => {noticeList.onGetAll(() => NoticeRepository.onGetNoticeList(params), { more: 'data' })}
const getNoticeDetail = (noticeNo: number, serviceId?: string) => {
    noticeDetail.onGetAll(() => NoticeRepository.onGetNoticeDetail(noticeNo, serviceId))
}

export const noticeStore = {
    noticeList,
    noticeDetail,
    getNoticeList,
    getNoticeListMore,
    getNoticeDetail,
}
